import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContainerComponent } from '@root/modules/super-admin/components/container/admin.component';
import { MerchantInfoComponent } from '@modules/super-admin/components/merchant-info/merchant-info.component';
import { DashboardComponent } from '@modules/super-admin/components/dashboard/dashboard.component';
import { MerchantsComponent } from '@modules/super-admin/components/merchants/merchants.component';
import { AdminsComponent } from '@modules/super-admin/components/admins/admins.component';
import { AdminGuardService } from '@services/admin-guard.service';
import { TransactionsComponent } from '@modules/super-admin/components/transactions/transactions.component';
import { TransactionDetailsComponent } from '@modules/dashboard/components/transaction-details/transaction-details.component';
import { FullTransactionHistoryComponent } from '@modules/dashboard/components/full-transaction-history/full-transaction-history.component';
import { DeactivateMerchantComponent } from './components/deactivate-merchant/deactivate-merchant.component';
import { AdminContainerComponent } from './components/admin-container/admin-container.component';
import { UsersComponent } from '../users/users.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { AdminInfoComponent } from './admin-info/admin-info.component';
import { SalesAgentComponent } from './components/sales-agent/sales-agent.component';
import { SalesMerchantComponent } from './components/sales-merchant/sales-merchant.component';
import { MerchantNumberComponent } from './merchant-number/merchant-number.component';

const routes: Routes = [
  {
    path: 'admin/dashboard',
    component: DashboardComponent,
    canActivate: [AdminGuardService],
  },
  {
    path: 'admin/admins',
    component: AdminContainerComponent,
    canActivate: [AdminGuardService],
  },
  {
    path: 'admin/sales-agent',
    component: SalesAgentComponent,
    canActivate: [AdminGuardService],
  },
  {
    path: 'admin/users',
    component: ContainerComponent,
    canActivate: [AdminGuardService],
    children: [
      {
        path: 'merchants',
        pathMatch: 'full',
        component: MerchantsComponent
      },
      {
        path: 'sales-agent-merchants',
        pathMatch: 'full',
        component: SalesMerchantComponent
      },
      {
        path: 'deactivateMerchants',
        pathMatch: 'full',
        component: DeactivateMerchantComponent
      },
      {
        path: 'admins',
        pathMatch: 'full',
        component: AdminsComponent
      },
    ]
  },
  {
    path: 'admin/users/users',
    component: UsersComponent,
    canActivate: [AdminGuardService],

  },
  {
    path: 'admin/users/users/:id',
    component: UserInfoComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/users/merchant/:id',
    component: MerchantInfoComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/merchants/transactions/:id',
    component: TransactionsComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/transactions/:id',
    component: TransactionDetailsComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/full-transaction-history/:accountId',
    component: FullTransactionHistoryComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/admins/user/:id',
    component: AdminInfoComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/sales-agent/merchant/:id',
    component: AdminInfoComponent,
    canActivate: [AdminGuardService]
  },
  {
    path: 'admin/sales-agent/saMerchant/:id',
    component: MerchantNumberComponent,
    canActivate: [AdminGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuperAdminRoutingModule { }
